<template>
    <div :key="key">
        <div v-if="deadline.menu.can_edit">
            <b-input
                ref="duration"
                v-model="form.duration"
                size="sm"
                :class="reactiveClass"
                class="number-font"
                style="cursor: pointer"
                @change="saveDeadline"
            />
        </div>
        <div v-else>
            <span class="number-font">{{ form.duration }}</span>
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../../common/mixins/TableFormHandler.vue'

export default {
    name: 'DurationForm',

    mixins: [TableFormHandler],

    props: {
        deadline: {
            type: Object,
            required: true,
        },
    },

    created() {
        this.align = 'right'
    },

    methods: {
        async saveDeadline() {
            try {
                await axios.put(
                    `/clientDeadlines/${this.deadline.id}/duration`,
                    this.form
                )
                this.handleSuccess()
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.duration = this.deadline.duration.toFixed(2)
        },

        setInitialKey() {
            this.key = `duration${this.deadline.id}`
        },

        unFocus() {
            this.$refs.duration.blur()
        },
    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
